<template>
  <div class="banner">
    <el-carousel trigger="click" height="100vh" :interval="5000">
      <el-carousel-item>
        <div class="banner-item">
          <oss-img src="https://img.kakaclo.com/web-img/home/login/img2.png" :width="960" :height="1080" />
        </div>
      </el-carousel-item>
      <!-- <el-carousel-item>
        <div class="banner-item f-c-c" :style="{ background: `url('https://img.kakaclo.com/web-img/home/login/bg_1.png')` }">
          <div class="welcome f--c fd-c">
            <img src="https://img.kakaclo.com/web-img/home/login/img1.png" alt="">
            <h3>Welcome to KakaClo</h3>
            <div class="text">
              KakaClo, an apparel platform with its own factory and integrated supply chain, provides the most professional dropshipping, wholesale and customization service.
            </div>
            <div class="foot f-c-c">
              <el-button type="text" @click="jump('/about-us')">About Us</el-button>
              <div class="line"></div>
              <el-button type="text" @click="jump('/faq')">FAQ</el-button>
              <div class="line"></div>
              <el-button type="text" @click="jump('blogs')">Blogs</el-button>
            </div>
          </div>
        </div>
      </el-carousel-item> -->
    </el-carousel>
  </div>
</template>

<script>
// import API from '@/api'

export default {
  data() {
    return {}
  },
  created() {
  },
  methods: {
    jump(type) {
      if (type === 'blogs') window.open('https://www.kakaclo.com/wp-blog')
      else this.$router.push(type)
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  /deep/ .banner-item {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;

    >img {
      height: 100%;
    }

    .welcome {
      width: 75%;
      min-width: 500px;
      >img {
        width: 100%;
      }
      h3 {
        font-size: 38px;
        color: #303133;
        margin: 12px 0 24px 0;
      }
      .text {
        width: 80%;
        text-align: center;
        line-height: 24px;
        color: #606266;
      }
      .foot {
        margin-top: 80px;
        .line{
          width: 1px;
          height: 16px;
          border-left: 1px solid #E1E4EA;
          margin: 0 20px;
        }
      }
    }
  }
}
</style>
